import { jsxs as m, jsx as t } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import { c as D } from "./index.CWkFp9WS.js";
import { q as f, l as u } from "./floating-ui.react.MkaYL6o7.js";
import { c as p } from "./ODSDatePicker.utils.Dvmx0txe.js";
import { O as n } from "./ODSColumn.B8Qu83P2.js";
import { O as x } from "./ODSRow.Du_e7gfN.js";
import { O as b } from "./ODSText.D6mgyggF.js";
import '../assets/ODSDatePickerDay.css';const I = d(
  ({
    showToday: O = !1,
    selected: a = !1,
    disabled: e = !1,
    inActiveMonth: r = !0,
    size: c,
    className: k,
    label: i,
    "aria-label": l,
    ...y
  }, S) => {
    const s = p(), { ref: P, index: o } = f();
    return /* @__PURE__ */ m(
      "button",
      {
        ref: u([S, P]),
        className: D(
          "ODSDatePickerDay",
          `ODSDatePickerDay--size-${c}`,
          { "ODSDatePickerDay--disabled": e },
          { "ODSDatePickerDay--selected": a },
          { "ODSDatePickerDay--inActiveMonth": r },
          k
        ),
        "aria-selected": a,
        disabled: e,
        ...y,
        tabIndex: s.activeDateIndex === o ? 0 : -1,
        autoFocus: s.activeDateIndex === o,
        children: [
          /* @__PURE__ */ t(
            n,
            {
              className: D(
                "ODSDatePickerDay-Background",
                `ODSDatePickerDay-Background--size-${c}`,
                { "ODSDatePickerDay-Background--selected": a },
                { "ODSDatePickerDay-Background--disabled": e }
              )
            }
          ),
          /* @__PURE__ */ m(x, { className: "ODSDatePickerDay-Content", children: [
            i && /* @__PURE__ */ t(
              b,
              {
                as: "span",
                className: D(
                  "ODSDatePickerDay-Label",
                  { "ODSDatePickerDay-Label--inActiveMonth": r },
                  { "ODSDatePickerDay-Label--selected": a },
                  { "ODSDatePickerDay-Label--disabled": e }
                ),
                "aria-label": l,
                children: i
              }
            ),
            O && /* @__PURE__ */ t(
              n,
              {
                className: D("ODSDatePickerDay-TodayIndicator", {
                  "ODSDatePickerDay-TodayIndicator--selected": a
                })
              }
            )
          ] })
        ]
      }
    );
  }
);
I.displayName = "ODSDatePickerDay";
export {
  I as O
};
//# sourceMappingURL=ODSDatePickerDay.iq_3GF3r.js.map
